import React from 'react';

import './generic-tag.scss';

interface GenericTagProps {
    testId?: string;
    text: string;
}

export const GenericTag: React.FC<GenericTagProps> = ({ testId, text }): React.ReactElement => {
    const defaultTestId = 'generic-tag';

    return (
        <span className="generic-tag" data-testid={testId || defaultTestId}>
            {text}
        </span>
    );
};
